export const THREADLIST_HEADER_HEIGHT = 182;
export const THREADLIST_FOOTER_HEIGHT = 40;
export const LAUNCHER_HEIGHT = 80;
export const LAUNCHER_WIDTH = 84;
export const OFFSET_HEIGHT = 64;
export const OFFSET_HEIGHT_EXTENDED = 76;
export const MOBILE_OFFSET_HEIGHT = 104;
export const MOBILE_OFFSET_HEIGHT_EXTENDED = 116;
export const SMALLEST_WIDGET_HEIGHT = 247;
export const WIDGET_SHADOW_WIDTH = 24;
export const CLOSE_BUTTON_AND_SPACING = 16 + 60 + 16;
export const SPACING_ABOVE_WIDGET = 24 + 20;
export const COMPOSER_INLINE_MARGIN = 16;
export const COMPOSER_BOTTOM_MARGIN = 16;
export const ASK_ME_ANYTHING_LAUNCHER_WIDTH = 300;
export const UPDATED_VISITOR_WIDGET_BORDER_RADIUS = 10;